import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { DOCUMENT }                  from '@angular/common';

import { MessagesService }       from '../../app-lite/messages/messages.service';
import { XeroClientCredentials } from '../../app-lite/xero/models/xero.client-credentials';
import { XeroService }           from '../../app-lite/xero/xero.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector     : 'wor-xero-sign-in',
  styles: [ require('./xero.sign-in.component.scss') ],
  template: require('./xero.sign-in.component.html')
})
export class XeroSignInComponent implements OnInit {
  loginSsoUrl = this.xeroService.loginSsoUrl;

  constructor (
    @Inject(DOCUMENT)
    private document       : Document,
    private messagesService: MessagesService,
    private xeroService    : XeroService
  ) {}

  loadScript () : void {
    const body = this.document?.body;

    if ( !body ) {
      return;
    }

    const existingScript = this.document.querySelector(`script[src="${ this.loginSsoUrl }"]`);

    if ( existingScript ) {
      return;
    }

    const script = this.document.createElement('script');

    script.async = true;
    script.src   = this.loginSsoUrl;
    script.type  = 'text/javascript';

    body.appendChild(script);
  }

  ngOnInit () : void {
    this.loadScript();
  }

  signIn () : void {
    this.xeroService.getClientCredentials()
    .then(( credentials : XeroClientCredentials ) => {
      const params = new URLSearchParams({
        client_id    : credentials.client_id,
        redirect_uri : credentials.redirect_uri,
        response_type: 'code',
        scope        : 'openid profile email',
        state        : '123'
      });

      window.location.assign(`${
        this.xeroService.loginUrl
      }?${
        params.toString()
      }`);
    })
    .catch(error => this.messagesService.error(error));
  }
}
